import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const useReCaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getReCaptchaToken = async (action) => {
    if (!executeRecaptcha) {
      console.error("reCAPTCHA not ready");
      return null;
    }

    try {
      const token = await executeRecaptcha(action);
    //   if (!window.grecaptcha || typeof window.grecaptcha.execute !== "function") {
    //     alert("reCAPTCHA not available");
    //     return;
    //   }

    //   // Send the token to the backend for verification
    //   const response = await fetch("http://localhost:5000/api/Cards/verify-captcha", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({ token }),
    //   });

    //   const data = await response.json();

    //   if (data.message === "Captcha verified successfully") {
    //     alert(data.message);
      
    //   } else {
    //     alert("Captcha verification failed");
    //     return null;
    //   }
      return token;
    } catch (error) {
      console.error("Error during captcha verification:", error);
      alert("An error occurred during captcha verification.");
      return null;
    }
  };

  return { getReCaptchaToken };
};

export default useReCaptcha;
